var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCameraFilled = function SvgCameraFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.083 5h-3.466l-.325-1.292a1.044 1.044 0 0 0-1.017-.791h-4.55c-.483 0-.9.325-1.017.791L6.383 5H2.917c-.575 0-1.042.467-1.042 1.042v10c0 .575.467 1.041 1.042 1.041h14.166c.575 0 1.042-.466 1.042-1.041v-10c0-.575-.467-1.042-1.042-1.042ZM10 14.167a3.126 3.126 0 0 1 0-6.25 3.126 3.126 0 0 1 0 6.25Z",
    fill: "current"
  })));
};
export default SvgCameraFilled;